import { useEffect } from "react";
import { api } from "@/lib/api";

/**
 * SiteVerificationMount — runs on every route in the SPA.
 *
 * Priority:
 *  1. Build-time env `REACT_APP_GSV` (baked into index.html at build → the
 *     ONLY path Google's raw-HTML crawler can see reliably).
 *  2. Admin-Settings DB token (fallback for JS-rendered crawlers + preview).
 *
 * Also cleans up an empty `<meta content="">` so we don't ship a broken tag.
 */
export default function SiteVerificationMount() {
    useEffect(() => {
        const removeIfEmpty = () => {
            const el = document.head.querySelector('meta[name="google-site-verification"]');
            if (el && !el.getAttribute("content")) el.remove();
        };
        removeIfEmpty();

        // If the build-time env var already populated the tag, we're done.
        const existing = document.head.querySelector('meta[name="google-site-verification"]');
        if (existing && existing.getAttribute("content")) return;

        let cancelled = false;
        api.get("/public/settings").then(({ data }) => {
            const token = (data?.google_site_verification || "").trim();
            if (!token || cancelled) return;
            let el = document.head.querySelector('meta[name="google-site-verification"]');
            if (!el) {
                el = document.createElement("meta");
                el.setAttribute("name", "google-site-verification");
                document.head.appendChild(el);
            }
            el.setAttribute("content", token);
        }).catch(() => {});

        return () => { cancelled = true; };
    }, []);
    return null;
}
